import selectGameKeys from './select-game-keys';
import { selectBestScoreFraction } from './best-score';

const selectScoreCardSurveillance = ({ surveillance }, phrases) => {
  if (!surveillance) return null;

  const { summary, headings: { latestRound } } = phrases;
  const {
    stats,
    missions,
    ...surveillancePhrases
  } = phrases.surveillance;

  const { timesPlayed } = surveillance;
  const latestGame = surveillance.games[0];
  const bestScore = selectBestScoreFraction(surveillance.games, 'score');

  return {
    latestRound,
    imageUrl: 'https://images.ctfassets.net/gtqjh9j40j4m/2YB2LX9XnXRvrBljYRG1OT/f8286103a9427b431e48fe0aa502c5d6/surveillance-player.jpg',
    videoUrl: 'https://videos.ctfassets.net/gtqjh9j40j4m/3nT1V2XSHkEI07ej7dzpL4/1c91a8548a7776c3fb6b828487359779/surveillance2.mp4',
    summary: [
      {
        key: 'times-played',
        value: timesPlayed,
        units: null,
        descriptor: summary.timesPlayed,
      },
      {
        key: 'best-score',
        value: bestScore,
        units: summary.correctAnswers,
        descriptor: summary.bestScore,
      },
    ],
    statsTotal: {
      classNames: 'stat-pair-space-between hero-stat',
      stats: [
        [stats.totalScore, `${latestGame.score}`],
      ],
    },
    statsMain: {
      classNames: 'stat-pair-space-between',
      stats: [
        [stats.incorrectAnswers, `${latestGame.incorrect}`],
        [stats.timedOut, `${latestGame.timeout}`],
        [stats.accuracy, `${(latestGame.accuracy * 100).toFixed(1) * 1}%`],
      ],
    },
    statsLevels: {
      classNames: 'stat-pair-space-between',
      stats: latestGame.messages.map((score, index) => (
        [`${stats.level} ${index + 1}`, `${score}`]
      )),
    },
    ...selectGameKeys({ surveillance }),
    ...surveillancePhrases,
  };
};

export default selectScoreCardSurveillance;
